import { z } from 'zod'

export const GetEventEncoderDetailsParser = z
  .object({
    id: z.number().nullable(),
    address: z.string().nullable(),
    contactInfo: z.string().nullable(),
    encodeTestStart: z.string().nullable(),
    encodeTestEnd: z.string().nullable(),
    encodingEngineer: z.object({ id: z.number(), email: z.string() }).nullable()
  })
  .nullable()

export type EventEncoderDetails = z.infer<typeof GetEventEncoderDetailsParser>
